/**
 * @file     common.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for common UI elements: brand name, theme labels, navigation labels, language options, and global action buttons. Also exports footer and notFound strings.
 */
export const common = {
  brand: 'Relta',
  settings: 'Settings',
  theme: {
    label: 'Appearance',
    dark: 'Dark',
    light: 'Light'
  },
  navigation: {
    // ─── New Components (added 2026-03-15) ───────────────────────────
    home: 'Home',
    menu: 'Open menu',
    closeMenu: 'Close menu',
    closeDrawer: 'Close drawer'
  },
  language: {
    label: 'Language',
    en: 'English',
    fr: 'French',
    hi: 'Hindi',
    fa: 'Persian',
    ar: 'Arabic',
    pt: 'Portuguese',
    es: 'Spanish',
    ru: 'Russian',
    pa: 'Punjabi',
    ur: 'Urdu'
  },
  preferences: {
    modalTitle: 'Choose your preferences',
    modalDone: 'Done',
  },
  actions: {
    subscribe: 'Subscribe',
    submitting: 'Submitting...',
    goHome: 'Go home',
    requestConsultation: 'Request consultation',
    openVideo: 'Play video',
    // ─── New Components (added 2026-03-15) ───────────────────────────
    confirm: 'Confirm',
    cancel: 'Cancel',
    saveChanges: 'Save changes',
    change: 'Change'
  }
} as const;

export const notFound = {
  title: 'Page not found',
  headline: 'Page not found',
  body: 'This page does not exist or has moved.',
  cta: 'Go home'
} as const;

export const error = {
  headline: 'Something went wrong',
  body: 'This page did not load.',
  retry: 'Try again',
  home: 'Home page',
  globalHeadline: 'Something went wrong',
  globalBody: 'An unexpected error occurred.',
  reload: 'Reload'
} as const;

export const footer = {
  descriptionTitle: 'Relta Real Estate',
  description: 'Find and compare BC homes for sale.',
  trustPhrase: 'Take your time and decide with the facts.',
  navLabel: 'Site links',
  app: {
    title: 'Get the Relta app',
    appStore: 'Download on the App Store',
    googlePlay: 'Get it on Google Play',
  },
  cta: {
    eyebrow: '',
    title: 'Pick where to start.',
    action: 'Find your deal'
  }
} as const;
